import { render } from "./header.vue?vue&type=template&id=f753a7fc&scoped=true&ts=true"
import script from "./header.vue?vue&type=script&lang=ts"
export * from "./header.vue?vue&type=script&lang=ts"

import "./header.vue?vue&type=style&index=0&id=f753a7fc&lang=sass&scoped=true"

import exportComponent from "/opt/nolan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f753a7fc"]])

export default __exports__